module.exports = __webpack_public_path__ + "static/media/path.ae82ba94.svg";